import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

const mutation = graphql`
  mutation newDocumentSaveAttachmentMutation(
    $documentSavePk: Int!
    $title: String!
    $file: Upload!
  ) {
    newDocumentSaveAttachment(
      documentSavePk: $documentSavePk
      title: $title
      attachmentFile: $file
    ) {
      ok
    }
  }
`;

const newDocumentSaveAttachment = (
  environment,
  variables,
  uploadables,
  callback
) => {
  commitMutation(environment, {
    mutation,
    variables,
    uploadables,
    onCompleted: (response, errors) => {
      callback(response, errors);
    },
    onError: err => {
      throw new Error(err);
    }
  });
};

export default newDocumentSaveAttachment;
